export default function original3() {
  debugger;
  console.log("The third original source");
}